import styles from './RateCard.module.scss';
import {
	BookingPermissionsSettings,
	LeadTimesSettings,
	PriceRules
} from '@components';
import { DEFAULT_RATE_CARD_RANGES } from '@types';

type TProps = {
	isDisabled?: boolean;
	type: keyof typeof DEFAULT_RATE_CARD_RANGES;
	itemTypeId?: string;
}

export const RateCardRules = (props:TProps) => {
	const {
		isDisabled = false,
		type,
		itemTypeId
	} = props;
	return (
		<>
			<div className={styles.expanders}>
				<LeadTimesSettings isDisabled={isDisabled} type={type} itemTypeId={itemTypeId} />
				<BookingPermissionsSettings isDisabled={isDisabled} />
				<PriceRules isDisabled={isDisabled} type={type} />
			</div>
		</>
	);
}
